module.exports = (__webpack_require__(0))(1);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/View.js from dll-reference girder_lib
// module id = 8
// module chunks = 0